import {CommonModule} from '@angular/common';
import {Component, input, output} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';

import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSliderModule} from '@angular/material/slider';
import {IQuestionForm} from '../../../../../utils/interfaces/poll';
import {SelectionComponent} from './selection/selection.component';
import {TextFieldComponent} from './text-field/text-field.component';
import {PollTypeEnum} from "../../../../../utils/enums/poll-type.enum";
import {TYPE_OF_POLL_PLACEHOLDER} from "./type-of-poll.const";

@Component({
  selector: 'app-type-of-poll',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    DragDropModule,
    SelectionComponent,
    TextFieldComponent,
    MatSliderModule,
    MatSlideToggleModule,
  ],
  templateUrl: './type-of-poll.component.html',
  styleUrl: './type-of-poll.component.scss',
})
export class TypeOfPollComponent {
  firstPage = input.required<boolean>();
  firstQuestion = input.required<boolean>();

  formQuestion = input.required<FormGroup<IQuestionForm>>();
  editMode = input.required<boolean>();

  pollType = input.required<PollTypeEnum>();

  onCreatedAnswer = output<{
    question: FormGroup<IQuestionForm>;
    weight: 1 | 2 | 3 | 4 | null;
    required: boolean;
  }>();

  get questionType(): number | null {
    return this.formQuestion()?.controls?.type?.value ?? null;
  }

  get isSatisfaction(): boolean {
    return this.pollType() === PollTypeEnum.Satisfaction;
  }

  get isReservation(): boolean {
    return this.pollType() === PollTypeEnum.Reservation;
  }

  get showSelection(): boolean {
    return this.questionType === 1 || this.questionType === 2;
  }

  get showTextField(): boolean {
    return this.questionType === 3;
  }

  get titlePlaceholder(): string {
    return this.isSatisfaction
      ? TYPE_OF_POLL_PLACEHOLDER.satisfactionTitle
      : TYPE_OF_POLL_PLACEHOLDER.reservationTitle;
  }

  get titleDescriptionPlaceholder(): string {
    return this.isSatisfaction
      ? TYPE_OF_POLL_PLACEHOLDER.satisfactionTitleDescription
      : TYPE_OF_POLL_PLACEHOLDER.reservationTitleDescription;
  }

  get textFieldPlaceholder(): string {
    return this.isSatisfaction
      ? TYPE_OF_POLL_PLACEHOLDER.satisfactionTextField
      : TYPE_OF_POLL_PLACEHOLDER.reservationTextField;
  }

  get textFieldLabel(): string {
    return this.isSatisfaction
      ? TYPE_OF_POLL_PLACEHOLDER.satisfactionLabel
      : TYPE_OF_POLL_PLACEHOLDER.reservationLabel;
  }

  get selectionPlaceholder(): string {
    return this.isSatisfaction
      ? TYPE_OF_POLL_PLACEHOLDER.satisfactionSelection
      : TYPE_OF_POLL_PLACEHOLDER.reservationSelection;
  }

  changeQuestionType(type: number) {
    this.formQuestion().controls.answers.clear();
    if (type === 1 || type === 2) {
      for (let i = 0; i < 2; i++) {
        this.onCreatedAnswer.emit({
          question: this.formQuestion(),
          weight: null,
          required: true,
        });
      }
    } else {
      this.onCreatedAnswer.emit({
        question: this.formQuestion(),
        weight: null,
        required: false,
      });
    }
  }

  changeCreatedAnswer() {
    this.onCreatedAnswer.emit({
      question: this.formQuestion(),
      weight: null,
      required: true,
    });
  }
}
